<template>
	<div id="app">
		<!-- 根据路由判断是否显示导航栏等组件 -->
		<div v-if="!isLoginPage">
			<!-- 顶部导航栏组件 -->
			<TopNavBar @shpwMenu="userMenuShow = true" v-if="shopStatus == 1 || !shopStatus" />
			<TopNavBarH @shpwMenu="painterMenuShow = true" v-else />

			<!-- 主要内容区域 -->
			<main class="main-content" v-if="shopStatus == 1 || !shopStatus">
				<router-view />
			</main>
			<div class="painter-content" v-else>
				<PainterSidebar class="painterSidebarPhone" />
				<main class="painter-main-content">
					<router-view />
				</main>
			</div>
			<!-- 底部导航栏组件 -->
			<BottomNavBar />

			<MsgSever ref="msgSever" v-if="shopStatus == 1 || !shopStatus" />
			<PainerMsgSever ref="painerMsgSever" v-else />
		</div>
		<!-- 登录页单独展示 -->
		<div v-else>
			<router-view />
		</div>
		<el-drawer :visible.sync="userMenuShow" direction="ltr" size="50%" :show-close="false">
			<nav class="phone-main-nav">
				<router-link to="/super-talk-community">超话社区</router-link>
				<router-link to="/creator-flower-market">创作者花市</router-link>
				<router-link to="/wonderful-activities">精彩活动</router-link>
				<router-link to="/surrounding-markets">周边市场</router-link>
				<router-link to="/creator-center">创作者中心</router-link>
			</nav>
		</el-drawer>
		<el-drawer class="painterMenu" :visible.sync="painterMenuShow" direction="ltr" size="42%" :show-close="false">
			<PainterSidebar />
		</el-drawer>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import TopNavBar from './components/TopNavBar.vue'
	import TopNavBarH from './components/TopNavBarH.vue'
	import PainterSidebar from './components/PainterSidebar.vue'
	import BottomNavBar from './components/BottomNavBar.vue'
	import MsgSever from './components/MsgSever.vue'
	import PainerMsgSever from './components/PainerMsgSever.vue'

	export default {
		name: 'App',
		components: {
			TopNavBarH,
			TopNavBar,
			PainterSidebar,
			BottomNavBar,
			MsgSever,
			PainerMsgSever
		},
		computed: {
			...mapState(['shopStatus']),
			// 判断当前是否为登录页
			isLoginPage() {
				return this.$route.path === '/register' || this.$route.path === '/login' || this.$route.path ===
					'/personal-like';
			}
		},
		data() {
			return {
				userMenuShow: false,
				painterMenuShow: false,
			}
		},
		watch: {
			$route: {
				handler(to, from) {
					if (to.path == '/') {
						if (this.shopStatus == 2 || !this.shopStatus) {
							localStorage.clear();
							this.$store.dispatch('updateShopStatus', 1)
						}
					}
					if (localStorage.getItem('token')) {
						this.$nextTick(() => {
							if (this.$refs.msgSever) {
								this.$refs.msgSever.userDetails()
							}
							if (this.$refs.painerMsgSever) {
								this.$refs.painerMsgSever.userDetails()
							}
						})
					}
					this.userMenuShow = false
					this.painterMenuShow = false
					console.log('当前路由:', to);
					console.log('之前的路由:', from);
				},
				deep: true, // 深度监听（可选）
				immediate: true // 初始化时立即触发（可选）
			}
		},
	}
</script>

<style lang="scss">
	/* 全局样式重置 */
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	#app {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* 主要内容区域样式 */
	.main-content {
		flex: 1;
	}

	.painter-content {
		display: flex;
	}

	.el-empty {
		&__image {
			width: 1.6rem !important;
		}

		&__description p {
			font-size: .14rem !important;
		}
	}
</style>
<style lang="scss" scoped>
	.phone-main-nav {
		display: flex;
		flex-direction: column;
		gap: .7rem;
		padding: 0 .2rem;
	}

	.phone-main-nav a {
		width: fit-content;
		text-decoration: none;
		font-weight: 500;
		font-size: .32rem;
		color: #000000;
		transition: color 0.3s;
	}

	.phone-main-nav a:hover {
		color: #6B3503;
	}

	.phone-main-nav .router-link-active {
		color: #6B3503;
		font-weight: 600;
		position: relative;
	}

	.phone-main-nav .router-link-active::after {
		content: '';
		position: absolute;
		bottom: -8px;
		left: 0;
		width: 100%;
		height: 2px;
		background-color: #6B3503;
	}

	.painterMenu {

		::v-deep .el-drawer {
			&__container {
				.el-drawer {
					background: #A8A481;
				}
			}
		}
	}

	@media (max-width: 480px) {
		.painter-main-content {
			height: calc(100vh - 3.18rem);
			width: calc(100%);
			background: #FAEFDD;
			overflow-y: auto;
		}

		.painterSidebarPhone {
			display: none;
		}
	}

	@media (min-width: 481px) {
		.painter-main-content {
			height: calc(100vh - 3.18rem);
			width: calc(100% - 2.56rem);
			background: #FAEFDD;
			overflow-y: auto;
		}

		.painterSidebarPhone {
			display: flex;
		}
	}
</style>